/*=========================================================================================
  File Name: moduleSettingsActions.js
  Description: Actions of the settings module.
==========================================================================================*/

import axios from '@/axios'

export default {
  // This action does two things:
  // 1-initializes the type of the billing template of the user
  // 2-stores the user's currency symbol in local storage
  initConfigurations({ commit }) {
    if (localStorage.getItem('accessToken')) {
      if (localStorage.getItem('template_type')) {
        commit('SET_TEMPLATE_TYPE', JSON.parse(localStorage.getItem('template_type')))
      } else {
        axios.get('/setting/firm/')
          .then(response => {
            const templateType = response.data.setting.templates.template
            commit('SET_TEMPLATE_TYPE', templateType)
            localStorage.setItem('template_type', templateType)
            localStorage.setItem('currency_symbol', response.data.setting.accounts.currency || 'RM')
          })
          .catch(error => {
            throw error
          })
      }
    }
  },
}
